// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   PayoutSettings.css — Facilitate Payout Settings
   Harmonized with Facilitate Design System (AdventureShared.css)
   ===================================================== */

.payout-settings-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 1000px;
  margin: 0;
}

/* ── Payout Status Card ── */
.payout-status-card {
  background-color: #0e1b1b;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}

.payout-status-row {
  display: flex;
  align-items: center;
  gap: 18px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.payout-status-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  flex-shrink: 0;
}

.payout-status-icon.connected {
  background-color: rgba(40, 167, 69, 0.15);
  color: #28a745;
  border: 1px solid rgba(40, 167, 69, 0.3);
}

.payout-status-icon.pending {
  background-color: rgba(255, 193, 7, 0.15);
  color: #ffc107;
  border: 1px solid rgba(255, 193, 7, 0.3);
}

.payout-status-icon.disconnected {
  background-color: rgba(220, 53, 69, 0.15);
  color: #dc3545;
  border: 1px solid rgba(220, 53, 69, 0.3);
}

.payout-status-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.payout-status-title {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.payout-status-desc {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #777;
  margin: 0;
  line-height: 1.5;
}

/* ── Verification & Capabilities Grid ── */
.payout-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.payout-detail-item {
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 10px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.payout-detail-item.active {
  border-color: rgba(72, 209, 204, 0.4);
  background: rgba(72, 209, 204, 0.04);
}

.payout-detail-item.inactive {
  border-color: rgba(220, 53, 69, 0.35);
  background: rgba(220, 53, 69, 0.03);
}

.payout-detail-label {
  font-family: 'Inter', sans-serif;
  font-size: 11.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #777;
  margin-bottom: 3px;
}

.payout-detail-value {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
}

/* ── Note Box ── */
.payout-note-box {
  background-color: rgba(72, 209, 204, 0.06);
  border: 1px solid rgba(72, 209, 204, 0.2);
  border-left: 4px solid #48d1cc;
  padding: 16px 20px;
  border-radius: 8px;
  font-size: 13.5px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.85);
  font-family: 'Inter', sans-serif;
}

.payout-note-box strong {
  color: #48d1cc;
}

/* ── Action Buttons ── */
.payout-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 6px;
}

.payout-btn-primary {
  background-color: #3bb3ae;
  color: #071414;
  border: none;
  border-radius: 24px;
  padding: 12px 26px;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.payout-btn-primary:hover:not(:disabled) {
  background-color: #48d1cc;
  box-shadow: 0 4px 14px rgba(72, 209, 204, 0.35);
  transform: translateY(-1px);
}

.payout-btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.payout-btn-secondary {
  background-color: transparent;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 24px;
  padding: 12px 26px;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.payout-btn-secondary:hover:not(:disabled) {
  background-color: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.4);
}

.payout-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  padding: 80px 0;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/PayoutSettings/PayoutSettings.css"],"names":[],"mappings":"AAAA;;;0DAG0D;;AAE1D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8DAA8D;AAChE;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,0CAA0C;EAC1C,yCAAyC;EACzC,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* =====================================================\n   PayoutSettings.css — Facilitate Payout Settings\n   Harmonized with Facilitate Design System (AdventureShared.css)\n   ===================================================== */\n\n.payout-settings-container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n  max-width: 1000px;\n  margin: 0;\n}\n\n/* ── Payout Status Card ── */\n.payout-status-card {\n  background-color: #0e1b1b;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\n}\n\n.payout-status-row {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.payout-status-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.payout-status-icon.connected {\n  background-color: rgba(40, 167, 69, 0.15);\n  color: #28a745;\n  border: 1px solid rgba(40, 167, 69, 0.3);\n}\n\n.payout-status-icon.pending {\n  background-color: rgba(255, 193, 7, 0.15);\n  color: #ffc107;\n  border: 1px solid rgba(255, 193, 7, 0.3);\n}\n\n.payout-status-icon.disconnected {\n  background-color: rgba(220, 53, 69, 0.15);\n  color: #dc3545;\n  border: 1px solid rgba(220, 53, 69, 0.3);\n}\n\n.payout-status-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.payout-status-title {\n  font-family: 'Inter', sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.payout-status-desc {\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  color: #777;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* ── Verification & Capabilities Grid ── */\n.payout-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.payout-detail-item {\n  background: rgba(255, 255, 255, 0.025);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 10px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n}\n\n.payout-detail-item.active {\n  border-color: rgba(72, 209, 204, 0.4);\n  background: rgba(72, 209, 204, 0.04);\n}\n\n.payout-detail-item.inactive {\n  border-color: rgba(220, 53, 69, 0.35);\n  background: rgba(220, 53, 69, 0.03);\n}\n\n.payout-detail-label {\n  font-family: 'Inter', sans-serif;\n  font-size: 11.5px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #777;\n  margin-bottom: 3px;\n}\n\n.payout-detail-value {\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n/* ── Note Box ── */\n.payout-note-box {\n  background-color: rgba(72, 209, 204, 0.06);\n  border: 1px solid rgba(72, 209, 204, 0.2);\n  border-left: 4px solid #48d1cc;\n  padding: 16px 20px;\n  border-radius: 8px;\n  font-size: 13.5px;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.85);\n  font-family: 'Inter', sans-serif;\n}\n\n.payout-note-box strong {\n  color: #48d1cc;\n}\n\n/* ── Action Buttons ── */\n.payout-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin-top: 6px;\n}\n\n.payout-btn-primary {\n  background-color: #3bb3ae;\n  color: #071414;\n  border: none;\n  border-radius: 24px;\n  padding: 12px 26px;\n  font-size: 14px;\n  font-weight: 700;\n  font-family: 'Inter', sans-serif;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.payout-btn-primary:hover:not(:disabled) {\n  background-color: #48d1cc;\n  box-shadow: 0 4px 14px rgba(72, 209, 204, 0.35);\n  transform: translateY(-1px);\n}\n\n.payout-btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.payout-btn-secondary {\n  background-color: transparent;\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 24px;\n  padding: 12px 26px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: 'Inter', sans-serif;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.payout-btn-secondary:hover:not(:disabled) {\n  background-color: rgba(255, 255, 255, 0.07);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.payout-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 14px;\n  padding: 80px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
